<template>
  <div class="bg">
    <div class="row" v-show="showPage">
      <div class="col-md-12 login-form-2">
        <!-- <h3>APEX</h3> -->
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <label
                style="width:7rem"
                class="input-group-text"
                for="inputGroupSelect01"
              >Your User Id</label>
            </div>
            <input type="text" v-model="userId" name id class="form-control" placeholder="*" />
            <!-- <small id="helpId" class="text-muted">Help text</small> -->
          </div>
        </div>

        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <label style="width:7rem" class="input-group-text" for="inputGroupSelect01">Password</label>
            </div>
            <input
              type="password"
              v-model="password"
              name="password"
              class="form-control"
              placeholder="*"
            />
            <!-- <small id="helpId" class="text-muted">Help text</small> -->
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="form-group text-left">
              <span
                @click="createAccount=true"
                style="color:#007bff;"
              >Forgot Password / Unlock Account</span>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group text-right">
              <input type="button" class value="Login" @click="clickLogin" />
            </div>
          </div>
        </div>

        <!-- <div class="form-group text-right">
          <a class="btnForgetPwd" value="Login">{{$t("ForgetPassword")}}?</a>
        </div>-->
      </div>

      <img
        style=" display: block;
        margin-top:5%;
  margin-left: auto;
  margin-right: auto;
  width: 70%;
  max-height:200px;"
        src="@/assets/images/APEX-logo-U2.jpg"
        alt
      />
    </div>
    <div v-if="isServerMaintenance" class="server-error">
      <!-- <i class="fas fa-exclamation-triangle"></i> -->
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="error-template">
              <h1 style="margin-top:20px">
                <i class="fas fa-exclamation-triangle"></i>
                Server Busy
              </h1>
              <!-- <h2>Not Found</h2> -->
              <br />
              <div class="error-details">
                Sorry, please wait a few minutes.
                <br />Click the "Refresh" icon to restart the system
                <!-- <br />Requested page not found! -->
              </div>
              <br />
              <div @click="getInfo" class="error-actions">
                <i style="font-size:80px; color:#FFF" class="fas fa-sync"></i>
                <br />
                <b style="color:#FFF">Refresh</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="createAccount"
      class="create-account-modal"
      style="position: fixed;  top: 0px; width: 100%; height: 100%;"
    >
      <div class="modal-dialog" role="document" style="z-index:1">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Forgot Password / Unlock Account</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="createAccount=false"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="form-group">
              <label for="exampleInputEmail1">User Id</label>
              <input type="text" class="form-control" v-model="createAccountForm.userId" />
              <i v-if="createAccountForm.userIdError==false">
                <i class="fa fa-check" aria-hidden="true"></i>
              </i>
            </div>
            <div class="form-group">
              <label for="exampleInputPassword1">Password</label>
              <input v-model="createAccountForm.password" type="password" class="form-control" />
              <i v-if="createAccountForm.passwordError==false">
                <i class="fa fa-check" aria-hidden="true"></i>
              </i>
            </div>
            <div class="form-group">
              <label for="exampleInputEmail1">Email address</label>
              <input
                ref="email"
                type="email"
                class="form-control"
                v-model="createAccountForm.email"
              />
              <i v-if="createAccountForm.emailError==false">
                <i class="fa fa-check" aria-hidden="true"></i>
              </i>
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click="createAccountCommit"
              type="button"
              class="btn btn-primary"
              :disabled="createAccountForm.userIdError || createAccountForm.passwordError || createAccountForm.emailError"
            >Commit</button>
          </div>
          <div
            v-if="createAccountForm.messageText"
            class="alert alert-primary"
            role="alert"
          >{{createAccountForm.messageText}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import StoreInfo from "@/components/base/StoreInfo.js";
export default {
  // mixins: [StoreInfo],
  name: "LoginPage",
  data: function() {
    return {
      createAccount: false,
      createAccountForm: {
        userId: "",
        password: "",
        email: "",
        userIdError: true,
        passwordError: true,
        emailError: true,
        messageText: null
      },

      userId: "",
      password: "",
      showPage: false,
      isServerMaintenance: false
    };
  },
  props: {
    msg: String
  },
  mounted: function() {
    this.getInfo();
  },
  watch: {
    createAccount: function() {
      this.createAccountForm = {
        userId: "",
        password: "",
        email: "",
        userIdError: true,
        passwordError: true,
        emailError: true,
        messageText: null
      };
    },
    "createAccountForm.userId": function(v) {
      if (this.createAccount == false) return;
      var isText = /^[a-zA-Z0-9]+$/;
      if (!isText.test(v)) {
        this.createAccountForm.userIdError = true;
        this.setMessageText("請勿包含特殊字元");
        return;
      }
      if (v.length < 6) {
        this.createAccountForm.userIdError = true;
        this.setMessageText("不得小於6個字元");
        return;
      }
      this.createAccountForm.userIdError = false;
    },
    "createAccountForm.password": function(v) {
      if (this.createAccount == false) return;
      var isText = /^[a-zA-Z0-9]+$/;
      if (!isText.test(v)) {
        this.createAccountForm.passwordIdError = true;
        this.setMessageText("請勿包含特殊字元");
        return;
      }
      if (v.length < 6) {
        this.createAccountForm.passwordError = true;
        this.setMessageText("不得小於6個字元");
        return;
      }
      this.createAccountForm.passwordError = false;
    },
    "createAccountForm.email": function(v) {
      if (this.createAccount == false) return;
      if (this.$refs.email.checkValidity() && v) {
        this.createAccountForm.emailError = false;
      } else {
        this.createAccountForm.emailError = true;
      }
    }
  },
  methods: {
    createAccountCommit: function() {
      if (
        this.createAccountForm.userIdError == false &&
        this.createAccountForm.passwordError == false &&
        this.createAccountForm.emailError == false
      ) {
        var _this = this;
        this.startLoad();
        this.$http
          .post("/WebApp/Authenticate/CreateAccount", {
            ...this.createAccountForm
          })
          .then(res => {
            var msg = res.data;
            if (msg.MessageType == "N") {
              _this.createAccountForm.messageText =
                "已成功送出申請，審核成功後，我們將寄發帳號、密碼給您";
            } else {
              _this.setMessageText(msg.MessageValue);
              //_this.createAccountForm.messageText = msg.MessageValue;
            }
            this.endLoad();
          })
          .catch(err => {
            _this.setMessageText("尚未開放申請");
            this.endLoad();
          });
      }
    },
    getInfo: function() {
      let _this = this;
      if (localStorage.apextoken) {
        _this.startLoad();

        //現階段有token表示可登入
        this.$http
          .post("/WebApp/Information/GetInformation", {
            language: window.localStorage["apexlanguage"]
          })

          .then(res => {
            _this.isServerMaintenance = false;
            if (res.data.LoginResult) {
              window.localStorage["apextoken"] = res.data.Token;
              _this.setCompanyList(res.data.Information.CompanyList);
              _this.setMenu(res.data.Information.Menu);
              _this.setCompanyId(res.data.Information.CompanyId);
              _this.setUserId(_this.userId);
              _this.setLanguage(
                window.localStorage["apexlanguage"] ||
                  res.data.Information.Language
              );

              _this.$i18n.locale =
                window.localStorage["apexlanguage"] ||
                res.data.Information.Language;
              _this.setLanguageList(res.data.Information.LanguageList);
              _this.setUserName(res.data.Information.UserName);
              _this.loginSuccess();
              this.$router.push("/");
            } else {
              window.localStorage["apextoken"] = "";
              _this.showPage = true;
              _this.setMessageText("Login failed");
            }
            _this.endLoad();
          })
          .catch(err => {
            _this.isServerMaintenance = true;
            // window.localStorage["apextoken"] = "";
            this.$router.push("/");
            _this.setMessageText(
              "The server is abnormal. Please try again later."
            );
            _this.showPage = false;
            _this.endLoad();
          });
      } else {
        _this.showPage = true;
      }
    },
    clickLogin: function() {
      var _this = this;
      _this.clearMessageText();
      _this.startLoad();
      let data = {
        userId: _this.userId,
        password: _this.password
      };
      _this.$http
        .post("/WebApp/Authenticate/Login", data)
        .then(res => {
          // debugger;
          if (res.data.LoginResult) {
            _this.loginSuccess();
            _this.setMessageText("Login success");
            window.localStorage["apextoken"] = res.data.Token;
            _this.setCompanyList(res.data.Information.CompanyList);
            _this.setMenu(res.data.Information.Menu);
            _this.setUserId(_this.userId);
            _this.setCompanyId(res.data.Information.CompanyId);
            _this.setLanguage(
              window.localStorage["apexlanguage"] ||
                res.data.Information.Language
            );
            _this.$i18n.locale =
              window.localStorage["apexlanguage"] ||
              res.data.Information.Language;
            _this.setLanguageList(res.data.Information.LanguageList);
            _this.setUserName(res.data.Information.UserName);
            this.$router.push("/menu");
          } else {
            window.localStorage["apextoken"] = "";
            _this.logout();
            if (res.data.Text == "Device Error") {
              _this.$router.push("/ErrorDevice");
            } else {
              _this.setMessageText(res.data.Text || `Login failed`);
            }
          }
          _this.endLoad();
        })
        .catch(err => {
          _this.setMessageText(
            "The server is abnormal. Please try again later."
          );
          _this.endLoad();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
body {
  background: #eeeeee;
}
.login-form-2 {
  padding: 9% 9% 3% 9%;
  background: #eee;
  // box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 9px 26px 0 rgba(0, 0, 0, 0.19);
  h3 {
    text-align: center;
    /* margin-bottom: 12%; */
    color: #fff;
    font-size: 68px;
  }
}

.btnSubmit {
  font-weight: 600;
  width: 25%;
  color: #282726;
  background-color: #96dc91;
  border: none;
  // border-radius: 1.5rem;
  padding: 2%;
}
.btnForgetPwd {
  color: #fff;
  font-weight: 600;
  text-decoration: none;
}
.btnForgetPwd:hover {
  text-decoration: none;
  color: #fff;
}
.server-error,
.bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background: #e17055;
}
.server-error {
  background: rgb(32, 201, 151);
}
.create-account-modal::after {
  content: "";
  display: block;
  background-color: #000;
  opacity: 0.5;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 0;
}
.form-group {
  position: relative;
}
.fa-check {
  position: absolute;
  bottom: 0.5rem;
  right: 1rem;
  color: green;
}
</style>
